import { connect } from "react-redux";
import PmAssignTicket from "./pmAssignTicket";
import { bindActionCreators } from "redux";
import {fetchPmTicketAssignee,postTicketAssignment} from "services/redux/maintenance/pmTicket/action";
const mapStateToProps = (state) => ({
  pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmTicketAssignee,
      postTicketAssignment,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmAssignTicket);
